// src/Dashboard/pages/user/Absences/AbsencesDashboard.jsx

import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScollToTop";
import { useAbsences } from "./hooks/useAbsences";

import AbsencesHeader from "./components/AbsencesHeader";
import AbsencesKpis from "./components/AbsencesKpis";
import AbsencesInfoCard from "./components/AbsencesInfoCard";
import AbsenceAdherentSelect from "./components/AbsenceAdherentSelect";
import AbsenceAdherentCard from "./components/AbsenceAdherentCard";
import AbsenceForm from "./components/AbsenceForm";
import AbsenceHistoryPreview from "./components/AbsenceHistoryPreview";
import AbsenceSkeleton from "./components/AbsenceSkeleton";
import AbsencesEmptyState from "./components/AbsencesEmptyState";

export default function AbsencesDashboard() {
  useScrollToTop();

  const {
    loading,
    error,

    adherents,
    selectedAdherent,
    selectedAdherentId,
    setSelectedAdherentId,

    form,
    updateForm,

    saving,
    marking,

    stats,

    saveAbsence,
    markReturned,
    refresh,
    resetForm,
  } = useAbsences();

  return (
    <section className="w-full pb-10 pt-5 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5 px-3 sm:px-4 lg:px-6">
        <AbsencesHeader loading={loading} onRefresh={refresh} />

        <AbsencesKpis stats={stats} loading={loading} />

        <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

          <div className="p-4 sm:p-5 lg:p-6">
            <div className="grid grid-cols-1 gap-5 xl:grid-cols-[minmax(0,1fr),380px]">
              <div className="space-y-5">
                <AbsencesInfoCard />

                {loading ? (
                  <AbsenceSkeleton />
                ) : error ? (
                  <div className="rounded-[24px] border border-red-200 bg-red-50 px-5 py-8 text-center text-sm text-red-700 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-300">
                    {error}
                  </div>
                ) : adherents.length === 0 ? (
                  <AbsencesEmptyState />
                ) : (
                  <>
                    <AbsenceAdherentSelect
                      adherents={adherents}
                      value={selectedAdherentId}
                      onChange={setSelectedAdherentId}
                    />

                    <AbsenceAdherentCard
                      adherent={selectedAdherent}
                      onMarkReturned={markReturned}
                      busy={marking}
                    />

                    <AbsenceForm
                      form={form}
                      updateForm={updateForm}
                      selectedAdherent={selectedAdherent}
                      saving={saving}
                      onSubmit={saveAbsence}
                      onReset={resetForm}
                    />
                  </>
                )}
              </div>

              <aside className="space-y-5">
                <AbsenceHistoryPreview
                  adherent={selectedAdherent}
                  loading={loading}
                />
              </aside>
            </div>
          </div>
        </section>
      </div>

      <ToastContainer />
    </section>
  );
}